import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import forward from '../../../assests/toc/forward.png'
import { ObjectTypeEnum, ObjectTypeNamesEnum } from "../../../models/ObjectTypeEnum";
import { ConstUserGroupEnum } from "../../../models/ConstUserGroupEnum";
import { getObjectTypeName, postsApi } from "../../../utils";
import { PermmisionPostsTypeEnumText } from "../../lms-shared/models/PermmisionPostsTypeEnum";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import classes from './ForwardLessonBtn.module.css'
import { onKeyDown } from "../../../service";
import CopyLinkBtn from "../../UI/Buttons/CopyLinkBtn/CopyLinkBtn";
import SuccessProjectPopup from "../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";

const ForwardLessonBtn = ({ ViewAnimate, type, data, setMessage, ViewText, icon, iconText, projectUrl }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const { uiData } = useSelector((state) => state.general);
    const { user, isAdmin } = useSelector(state => state.auth);
    const dispatch = useDispatch()
    const [postId, setPostId] = useState(null);
    const [hideTopHeader, setHideTopHeader] = useState(false);

    let urlDirect = `${window.location.origin}${uiData.baseName}${homeUrl}${projectUrl ? '' : (type === ObjectTypeEnum.Project ? '/projectCode' : type === ObjectTypeEnum.Lesson ? '/lesson' : '')}/`;
    let urlProjectRunner = `${window.location.origin}${uiData.baseName}${homeUrl}/projectRunner/`

    useEffect(() => {
        if (postId) {
            setMessage(<SuccessProjectPopup minHeight={ViewAnimate ? '365px' : "257px"} myHeight={ViewAnimate ? '330px' : "257px"} myWidth={'554px'} close={e => closeMessage(e)} color="#CCF0F0" title={texts.sendProject}>
                <div className={classes.CopyLinks} >
                    <div className={classes.CopyLinkContainer} >
                        <CopyLinkBtn title={ViewText} url={urlDirect + postId}></CopyLinkBtn>
                    </div>

                    {ViewAnimate && <div className={classes.CopyLinkContainer} >
                        <CopyLinkBtn title={texts.copyLinkToViewProject} url={urlProjectRunner + postId + (hideTopHeader ? '?noheader=1' : '')} checked={hideTopHeader} setChecked={isAdmin && setHideTopHeader} checkboxText={texts.withoutTopHeader} />
                    </div>}
                </div>
            </SuccessProjectPopup>);
        }
    }, [postId, hideTopHeader])

    function forwardFunc(e) {
        e.stopPropagation()
        if (projectUrl)
            setPostId(projectUrl);
        else {
            const dataApiFilter = {
                refObjectId: data?.id,
                refObjectType: getObjectTypeName(type),
                sourceObjectId: user.id,
                sourceObjectType: ObjectTypeNamesEnum.User,
                targetObjectId: ConstUserGroupEnum.Public,
                targetObjectType: ObjectTypeNamesEnum.ConstUserGroup
            }

            postsApi.postsFilterRangePost({ postsRangeFilter: dataApiFilter }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageTitleProjectSharePost, error: error, statusCode: response?.statusCode, message: "postsFilterPost " + error.message, level: 1, component: "ForwardLessonBtn", line: 54 }))
                }
                else {
                    if (resdata && resdata.length > 0) {
                        setPostId(resdata[0].id);
                        if (resdata[0].hasChange) {
                            updateContentPost(resdata[0])
                        }
                    }
                    else {
                        let dataApiAdd = {
                            name: data?.name,
                            targetObjectType: ObjectTypeNamesEnum.ConstUserGroup,
                            refObjectId: data?.id,
                            refObjectType: getObjectTypeName(type),
                            shares: [
                                {
                                    targetObjectId: ConstUserGroupEnum.Public,
                                    permissionMask: PermmisionPostsTypeEnumText.RunnerAndCode
                                }
                            ]
                        }
                        postsApi.postsAddPost({ postAddInput: dataApiAdd }, (error, addResdata, response) => {
                            if (error) {
                                dispatch(throwApiError({ userMessage: texts.MessageTitleProjectSharePost, error: error, statusCode: response?.statusCode, message: "postsFilterPost " + error.message, level: 1, component: "ForwardLessonBtn", line: 79 }))
                            }
                            else {
                                setPostId(addResdata.id);
                            }
                        })
                    }
                }
            })
        }
    }

    function updateContentPost(dataPost) {
        postsApi.postsUpdateContentIdPost(dataPost?.id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsUpdateContentIdPost " + error.message, level: 1, component: "ForwardLessonBtn", line: 95 }))
            }
            else {
                console.log("update");
            }
        })
    }

    const closeMessage = (e) => {
        e.stopPropagation();
        setMessage(null);
        setPostId(null);
    }

    return (
        <>
            {iconText ?
                <div className={classes.ForwardContainer} onClick={(e) => forwardFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => forwardFunc(e))}>
                    <div className={classes.ForwarddBtnText} >{iconText} </div>
                    <div className={classes.ForwardImgIcon} style={{ backgroundImage: `url(${icon})` }}></div>
                </div> :
                <img src={icon || forward} alt="ForwardIcon" className={classes.ForwardImg} onClick={(e) => forwardFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => forwardFunc(e))} />
            }
        </>
    )
}

export default ForwardLessonBtn;